import { admin } from 'controllers/admin';
import { cruise } from './cruise';
import { groundTransportation } from 'src/common/controllers/ground-transportation';
import { hotel } from 'controllers/hotel';
export const controllers = [...admin, ...hotel, ...groundTransportation, ...cruise];